import { FunctionComponent } from "react";
import React, { useEffect } from "react";
import styles from "./ColinsWidget.module.scss";

const CollinsWidget: FunctionComponent<any> = (props) => {

    const attributes = props?.content?.colinsAttributesList?.reduce((acc: any, attribute: any) => {
        acc[attribute?.content?.attributeText] = attribute?.content?.value;
        return acc;
    }, {});

    const loadScript = async (src: string) => {
        const promise = new Promise<void>((resolve, _reject) => {
            const scriptElement = document.createElement("script");

            scriptElement.src = '//widgets.designmynight.com/bookings-partner.min.js';
            scriptElement.setAttribute('venue', `${props?.content?.venueId}`);
            Object.entries(attributes).forEach(([key, value]) => {
                scriptElement.setAttribute(`${key}`, `${value}`);
            });
            scriptElement.onload = () => {
                resolve();
            };
            document.body.querySelector(`.${styles.content}`)?.appendChild(scriptElement);
            scriptElement.src = src;
        });
        return promise;
    };

    useEffect(() => {
        loadScript("//widgets.designmynight.com/bookings-partner.min.js");
        return () => {
            const scriptElement = document.querySelector(`script[src="//widgets.designmynight.com/bookings-partner.min.js"]`);
            if (scriptElement) {
                scriptElement.parentNode?.removeChild(scriptElement);
            }
        };
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {/* Script goes here */}
            </div>
        </div>
    );
}

export default CollinsWidget;